module.exports = __webpack_public_path__ + "img/game9.03b5b68e.png";